import ApplicationController from './application_controller.js'
import axios from 'axios'
import qs from 'qs'
import State from './ifiles/state.js'

export default class FilteredTable extends ApplicationController {

  connect() {
    this.evtL1 = this.evtHandler.bind(this)
    this.element.addEventListener('click', this.evtL1, false)
    this.element.addEventListener('change', this.evtL1, false)
    this.element.addEventListener('keyup', this.evtL1, false)
    this.element.querySelectorAll('.column_title').forEach(function (column) {
      if (column.dataset.sortDir == "none") {
        column.style.cssText += "cursor: default"
      }
    })
  }

  disconnect() {
    this.element.removeEventListener('click', this.evtL1, false)
    this.element.removeEventListener('change', this.evtL1, false)
    this.element.removeEventListener('keyup', this.evtL1, false)
  }

  //
  // Construit une querystring à partir de tous les input et select de filtered table (y compris hidden)
  //
  buildQueryString() {
    let data = {}
    const controls = this.element.querySelectorAll("input.filtered_table_control, select.filtered_table_control")
    controls.forEach(function (control) {
      data[control.getAttribute("name")] = control.value;
    })
    return qs.stringify(data)
  }

  //
  // Exécute la requête de filtrage et met à jour le tbody et tfoot de la filtered table
  //
  executeFilterQuery() {
    axios.get(`${this.element.dataset.path}/?${this.buildQueryString()}`)
      .then(response => {
        const tbody = document.querySelector("#filtered_table tbody");
        const tfoot = document.querySelector("#filtered_table tfoot");
        tbody.outerHTML = response.data.tbody
        tfoot.outerHTML = response.data.tfoot
        State.editor_opened = false
      })
  }

  //
  // Gestion des évènements pour les inputs et boutons
  //
  evtFilteredControl(e) {
    switch (e.type) {
      case 'click':
        if (e.target.matches('.export_xls')) {
          window.location.href += ('.xlsx?' + this.buildQueryString())
        }

        if (e.target.matches('.pagination .page')) {
          this.element.querySelector('input[name="filter_changed"]').value = 0
          this.element.querySelector('input[name="filter_page_number"]').value = e.target.dataset.pageNumber
          this.executeFilterQuery()
        }

        if (e.target.matches('.column_title')) {
          const current_sort = e.target.dataset.sortDir;
          if (current_sort != "none") {
            this.element.querySelector('input[name="filter_changed"]').value = 1
            this.element.querySelector('input[name="filter_sort_column"]').value = e.target.dataset.columnName
            this.element.querySelector('input[name="filter_sort_dir"]').value = current_sort
            this.executeFilterQuery()

            const new_sort = current_sort === 'asc' ? 'desc' : 'asc';
            e.target.dataset.sortDir = new_sort;

            e.target.closest('thead').querySelector('td').classList.remove('sorting_asc');
            e.target.closest('thead').querySelector('td').classList.remove('sorting_desc');
            e.target.closest('td').classList.add('sorting_' + new_sort);
          }
        }
        break

      case 'change':
        this.element.querySelector('input[name="filter_changed"]').value = 1
        this.executeFilterQuery()
        break

      case 'keyup':
        if (e.target.matches('input, input.input-date')) {
          let min_length = 2
          if (e.target.matches('input.input-date'))
            min_length = 10 // DD/MM/YYYY
          let val = e.target.value;
          if (val.length >= min_length || val.length === 0) {
            this.element.querySelector('input[name="filter_changed"]').value = 1;
            this.executeFilterQuery()
          }
        }
        break
    }
  }

  evtHandler(e) {
    if (e.target.matches('.filtered_table_control, .column_title, .export_xls')) {
      this.evtFilteredControl(e);
    }
  }

}